import {management} from '../../../../index'

import {FarmsDapRepository} from '../../../infra/knex/repositories/farmsDapRepository'
import {CheckFarmsWithData} from './checkFarmsWithData'


export const checkFarmsWithData = new CheckFarmsWithData(new FarmsDapRepository(management))
